import { IconNames } from '@setplex/arcane'
import { sample } from 'effector'
import { notification } from '~/features/notification'
import { NOTIFICATION_MESSAGE } from '~/shared/constants/messages'
import {
  addLiveChannelToFavoritesFx,
  addMovieToFavoritesFx,
  addTvshowToFavoritesFx,
  removeLiveChannelFromFavoritesFx,
  removeMovieFromFavoritesFx,
  removeTvshowFromFavoritesFx,
} from './model'

// Show notification when item is successfully added to favorites
sample({
  clock: [
    addMovieToFavoritesFx.done,
    addLiveChannelToFavoritesFx.done,
    addTvshowToFavoritesFx.done,
  ],
  fn: () => ({
    text: NOTIFICATION_MESSAGE.ADDED_TO_FAVORITES,
    icon: IconNames.plus,
  }),
  target: notification.showNotification,
})

// Show notification when item is successfully removed from favorites
sample({
  clock: [
    removeMovieFromFavoritesFx.done,
    removeLiveChannelFromFavoritesFx.done,
    removeTvshowFromFavoritesFx.done,
  ],
  fn: () => ({
    text: NOTIFICATION_MESSAGE.REMOVED_FROM_FAVORITES,
    icon: IconNames.check,
  }),
  target: notification.showNotification,
})
